import { Component, Input, EventEmitter, Output } from '@angular/core';
import { HelperService } from '../../helper.service';

@Component({
    selector: 'app-edit-box',
    templateUrl: './edit-box.component.html',
    styleUrls: ['./edit-box.component.scss']
})

export class EditBoxComponent {
    showEditMode: boolean = false;
    @Input() label: string;
    @Input() isNumeric: boolean;
    @Input() model: any;
    @Output() onModelChange: EventEmitter<any> = new EventEmitter<any>();
    newModelValue: any;
    isMobile = false;
    constructor(private helperService: HelperService) {
        this.isMobile = this.helperService.isMobile;
    }

    setEditMode() {
        this.showEditMode = true; 
        this.newModelValue = this.model;
    }

    save() {
        this.onModelChange.emit(this.model);
    }

    setReadMode() {
        this.showEditMode = false;
        this.newModelValue = '';
    }

    safeCharactersCheck(event: any) {
        let intersection = event.key.toLowerCase().split('').filter(x => 'čćšđž'.includes(x));
  
    }

    /*
    safeCharactersCheck(event: any) {
        let intersection = event.key.toLowerCase().split('').filter(x => 'čćšđž'.includes(x));
        if (event.key.toLowerCase().includes(' ') || intersection.length > 0) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
    }
    */
}